// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".x-menu-icon[data-v-1869f661]{color:#212528;font-size:1.5rem;line-height:4rem;text-align:center;width:4rem}.x-menu-icon.circle[data-v-1869f661]{border-radius:2rem;height:3.5rem;line-height:3.5rem;margin:.25rem;overflow:hidden;width:3.5rem}.x-menu-icon button[data-v-1869f661]{transform:scale(.625)}.x-menu-icon button[data-v-1869f661]:focus{outline:none}.x-menu-icon .hamburger-box[data-v-1869f661]{vertical-align:middle}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
